module.exports = __webpack_public_path__ + "static/media/manual-screen-4.d34833d1.png";